const POSITIONS = {
	LOCATION: {
		GENERAL_MANAGER: "General Manager",
	},
	SALES: {
		SALES_ASSOCIATE: "Sales Associate",
		SALES_MANAGER: "Sales Manager",
		GENERAL_SALES_MANAGER: "General Sales Manager",
	},
	FINANCE: {
		FINANCE_MANAGER: "F&I Manager",
		FINANCE_DIRECTOR: "Finance Director",
	},
	BDC: {
		BDC_SALES_ASSOCIATE: "BDC Sales Associate",
		BDC_SERVICE_ASSOCIATE: "BDC Service Associate",
		BDC_MANAGER: "BDC Manager",
	},
	SERVICE: {
		SERVICE_TECHNICIAN: "Service Technician",
		SERVICE_ADVISOR: "Service Advisor",
		SERVICE_MANAGER: "Service Manager",
		SERVICE_DIRECTOR: "Service Director",
		SERVICE_FOREMAN: "Service Foreman",
		INTERNAL_SERVICE_ADVISOR: "Internal Service Advisor",
	},
	BODY_SHOP: {
		BODY_SHOP_MANAGER: "Body Shop Manager",
		BODY_SHOP_PRODUCT_MANAGER: "Body Shop Product Manager",
		BODY_SHOP_TECHNICIAN: "Body Shop Technician",
		BODY_SHOP_PAINTER: "Body Shop Painter",
		BODY_SHOP_ESTIMATOR: "Body Shop Estimator",
		BODY_SHOP_FOREMAN: "Body Shop Foreman",
	},
	PARTS: {
		PARTS_COUNTER_ASSOCIATE: "Parts Counter Associate",
		PARTS_MANAGER: "Parts Manager",
		PARTS_DIRECTOR: "Parts Director",
	},
};

export default POSITIONS;
